/* Activity bus (Phase 6) — live bid/lot events observed by any mounted event
   socket are forwarded here so the floating Activity Center can show them,
   whatever page the visitor is on. Module-level pub/sub, bounded buffer. */
import { useEffect, useState } from "react";

let items = [];
let seq = 0;
const lastPrice = new Map(); // lot_id -> cents (dedupe repeated lot_update pushes)
const subs = new Set();

export const pushActivity = (item) => {
  items = [{ id: `a${++seq}`, ts: Date.now(), ...item }, ...items].slice(0, 30);
  subs.forEach((fn) => fn(items));
};

/** Called by useEventSocket for every event-room message. */
export const forwardEventActivity = (msg) => {
  if (!msg?.lot?.id) return;
  if (msg.type === "lot_closed") {
    lastPrice.delete(msg.lot.id);
    pushActivity({
      kind: "closed",
      lot_id: msg.lot.id,
      lot_number: msg.lot.lot_number,
      amount_cents: msg.lot.current_price_cents,
      currency: msg.lot.currency || "EUR",
    });
    return;
  }
  if (msg.type === "lot_update" && msg.lot.current_price_cents != null) {
    if (lastPrice.get(msg.lot.id) === msg.lot.current_price_cents) return; // not a new bid
    lastPrice.set(msg.lot.id, msg.lot.current_price_cents);
    pushActivity({
      kind: "bid",
      lot_id: msg.lot.id,
      lot_number: msg.lot.lot_number,
      amount_cents: msg.lot.current_price_cents,
      currency: msg.lot.currency || "EUR",
    });
  }
};

export const useActivity = () => {
  const [list, setList] = useState(items);
  useEffect(() => {
    subs.add(setList);
    return () => subs.delete(setList);
  }, []);
  return list;
};
